// Shows the selected table records that will accompany the next message.
import { useSyncExternalStore } from 'react';

import { AttachmentPillBand } from '@apps/web/features/phoebe_chat_v3/ui/primitives/attachment_pill_band';
import { ReferenceBadge } from '@apps/web/features/phoebe_chat_v3/ui/primitives/reference_badge';
import { type createTableSelectionStore } from '@apps/web/features/phoebe_chat_v3/ui/table_selection_context';

const ENTITY_TYPES = {
    shift_id: 'shift',
    caregiver_id: 'caregiver',
    client_id: 'client',
} as const;

export function TableSelectionAttachments({
    store,
}: Readonly<{
    readonly store: ReturnType<typeof createTableSelectionStore>;
}>) {
    const selection = useSyncExternalStore(store.subscribe, store.getSnapshot);
    if (selection === null || selection.ids.size === 0) {
        return null;
    }
    const type = ENTITY_TYPES[selection.idColumn];

    return (
        <section aria-label="Selected records attached to message">
            <AttachmentPillBand
                pills={Array.from(selection.ids, (id) => ({
                    id,
                    pill: <ReferenceBadge type={type} id={id} />,
                }))}
                onClear={() => store.update(null)}
                clearLabel="Remove all selected records from message"
            />
        </section>
    );
}
